module.exports = __webpack_public_path__ + "static/media/Lebenslauf.6827162e.pdf";